// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {BannerSize, BannerTheme} from 'common/components/banner/types';
import {BannerEl} from 'common/components/banner';
import {DropdownBannerEl} from 'common/components/banner/dropdown';

import type {ReportBanners} from './index';

export function template(this: ReportBanners) {
  return (
    <div sel='.mp-report-banners' class={{'has-banners': this.helpers.areBannersVisible()}}>
      {this.state.banners.map((banner, bannerIdx) =>
        banner.dropdown ? (
          <DropdownBannerEl
            class={{'banner-hidden': !banner.visible || this.state.hiddenBannerIdentifiers.has(banner.identifier)}}
            attrs={{
              size: banner.size || BannerSize.Medium,
              theme: banner.type || BannerTheme.Info,
              'header-text': banner.title,
              'body-text': banner.message,
              dropdown: banner.dropdown,
              'banner-tracking-type': banner.trackingType,
            }}
          />
        ) : (
          <BannerEl
            class={{'banner-hidden': !banner.visible || this.state.hiddenBannerIdentifiers.has(banner.identifier)}}
            attrs={{
              'banner-tracking-type': banner.trackingType,
              'body-text': banner.message,
              ctas: banner.ctas,
              'header-text': banner.title,
              size: banner.size || BannerSize.Medium,
              theme: banner.type || BannerTheme.Info,
              tooltip: banner.tooltip,
              multiline: banner.multiline,
            }}
            on={{
              action: (ev) => this.helpers.handleBannerAction(ev, bannerIdx, banner.name),
            }}
          />
        ),
      )}
    </div>
  );
}
